module.exports = __webpack_public_path__ + "static/img/YF.4720894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YF.png
// module id = p4bI
// module chunks = 34